import differenceInYears from 'date-fns/differenceInYears';
import parse from 'date-fns/parse';

export const getCurrentAge = (date: string) => {
	const birthDate = parse(date, 'yyyy-MM-dd', new Date());
	let age = differenceInYears(new Date(), birthDate);
	let txt = '';

	if (age >= 5 && age <= 20) {
		txt = 'лет';
	} else {
		age = age % 10;
		if (age === 1) {
			txt = 'год';
		} else if (age >= 2 && age <= 4) {
			txt = 'года';
		} else {
			txt = 'лет';
		}
	}

	return `${age} ${txt}`;
};
